var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"gray_tool_tip",attrs:{"effect":"dark","content":_vm.text,"placement":"right","visible-arrow":false}},[_c('i',{staticClass:"el-icon-warning"})])
}
var staticRenderFns = []

export { render, staticRenderFns }